import React from 'react';
import { Heart, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer
      className="py-16 relative"
      style={{ background: '#2e6abf' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white/20">
                <img
                  src="/logo.png"
                  alt="Sage And Seed Logo"
                  className="w-full h-full object-cover transform scale-[1.5]"
                />
              </div>
              <span className="text-2xl font-bold tracking-tight text-[#F6F6F6]" style={{ fontFamily: 'Merriweather, serif' }}>
                Sage And Seed
              </span>
            </div>
            <p className="text-[#D6E4F0] max-w-sm leading-relaxed">
              Restoring connection, purpose, and joy across generations. We bridge the gap between seniors and young adults through meaningful sessions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold mb-6 text-lg text-[#F6F6F6]">Explore</h3>
            <ul className="space-y-3">
              {[
                { id: 'about', label: 'About Us' },
                { id: 'how-it-works', label: 'How It Works' },
                { id: 'offerings', label: 'Offerings' },
                { id: 'benefits', label: 'Benefits' },
                { id: 'research', label: 'Research' },
                { id: 'news', label: 'News' }
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-sm transition-colors duration-200 text-[#D6E4F0] hover:text-[#F6F6F6] hover:underline"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold mb-6 text-lg text-[#F6F6F6]">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#D6E4F0]" />
                <a href="mailto:rayan.ashish@icloud.com" className="text-sm text-[#D6E4F0] hover:text-[#F6F6F6] hover:underline">
                  rayan.ashish@icloud.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"
        >
          <p className="text-sm text-[#D6E4F0]">
            © 2025 Sage And Seed. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <button className="text-xs text-[#D6E4F0] hover:text-[#F6F6F6] hover:underline">
              Privacy Policy
            </button>
            <button className="text-xs text-[#D6E4F0] hover:text-[#F6F6F6] hover:underline">
              Terms of Service
            </button>
            <button className="text-xs text-[#D6E4F0] hover:text-[#F6F6F6] hover:underline">
              Accessibility
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
